import { render, staticRenderFns } from "./table-survey.vue?vue&type=template&id=cebd1504&scoped=true"
import script from "./table-survey.vue?vue&type=script&lang=js"
export * from "./table-survey.vue?vue&type=script&lang=js"
import style0 from "./table-survey.vue?vue&type=style&index=0&id=cebd1504&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cebd1504",
  null
  
)

export default component.exports